export const zhCN_dashboard = {
  'app.dashboard.overview.totalSales': '总销售额',
  'app.dashboard.overview.visits': '访问量',
  'app.dashboard.overview.payments': '支付笔数',
  'app.dashboard.overview.operationalEffect': '运营活动效果',
  'app.dashboard.overview.wowChange': '周同比',
  'app.dashboard.overview.dodChange': '日同比',
  'app.dashboard.overview.dailySales': '日销售额',
  'app.dashboard.overview.visits.dailyVisits': '日访问量',
  'app.dashboard.overview.conversionRate': '转化率',
  'app.dashboard.salePercent.proportionOfSales': '销售额类别占比',
  'app.dashboard.salePercent.all': '全部',
  'app.dashboard.salePercent.online': '线上',
  'app.dashboard.salePercent.offline': '线下',
  'app.dashboard.timeline.traffic': '客流量',
  'app.dashboard.timeline.payments': '支付笔数',
};
